<template>
  <div class="page_acSet">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支 </el-breadcrumb-item>
          <el-breadcrumb-item>财务设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="changeTab">
          <el-tab-pane label="财务成本规则" name="0"></el-tab-pane>
          <el-tab-pane label="费用科目" name="1"></el-tab-pane>
          <el-tab-pane label="合作账户" name="3"></el-tab-pane>
          <el-tab-pane label="打款设置" name="2"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName2" @tab-click="changeTab2" v-if="activeName==3">
          <el-tab-pane label="真实账户" name="3"></el-tab-pane>
          <el-tab-pane label="虚拟账户" name="4"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex" style="margin-bottom:15px">
          <el-button type="success" size="small" v-if="activeName == '0'" @click="addRule">新增规则</el-button>
          <el-button type="success" size="small" v-if="activeName == '2'" @click="addPaySet">新增</el-button>
          <el-button type="success" size="small" v-if="activeName == '3'" @click="addAccount">新增</el-button>
          <!-- <el-button type="primary" size="small">导出</el-button> -->
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" v-if="activeName=='0'">
          <el-table-column prop="ruleNum" label="规则编号" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ruleName" label="规则名称" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="priority" label="优先级" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="fundUse" label="资金用途" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="expendpattern" label="支出方式" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="projectNames" label="适用项目" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="fundDayUp" label="区间上限天数" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.fundDayUp ? row.fundDayUp : '不限' }}</template>
          </el-table-column>
          <el-table-column prop="fundDayDown" label="区间下限天数" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.fundDayDown ? row.fundDayDown : '不限' }}</template>
          </el-table-column>
          <el-table-column prop="fundUp" label="区间上限金额" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.fundUp ? row.fundUp : '不限' }}</template>
          </el-table-column>
          <el-table-column prop="fundDown" label="区间下限金额" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.fundDown ? row.fundDown : '不限' }}</template>
          </el-table-column>
          <el-table-column prop="rateType" label="费率类型" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rate" label="费率" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.rate }}%</template>
          </el-table-column>
          <el-table-column prop="disableStr" label="启用状态" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="effectStart" label="生效期限" min-width="200" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.effectStart ? row.effectStart.split('T')[0] : '' }} ~ {{ row.effectEnd ? row.effectEnd.split('T')[0] : ''}}</template>
          </el-table-column>
          <el-table-column prop="name" label="操作" min-width="180" :show-overflow-tooltip="true" align="center" fixed="right">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button type="text" @click="enable(row)">{{ row.disableStr =='启用' ? '停用' : '启用' }}</el-button>
                <el-button type="text" @click="editRule(row)">编辑</el-button>
                <el-button type="text" @click="setProject(row)">适用项目</el-button>
                <el-popconfirm title="请确认是否删除" @confirm="del(row)" style="margin-left:10px;">
                  <el-button type="text" v-preventReClick slot="reference">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="departTree" v-if="activeName=='1'">
          <el-tree :data="treeData" :load="loadNode" lazy>
            <span class="custom-tree-node" slot-scope="{ node, data }" @mouseenter="mouseenter(data)" @mouseleave="mouseleave(data)">
              <span class="level_item"> {{data.name + '（' + data.code + '）' }} </span>
              <span class="departTree_btn" v-show="data.show">
                <el-button type="text" icon="el-icon-plus" @click.stop="() => append(node,data)" title="新增"></el-button>
                <el-button type="text" icon="el-icon-edit" @click.stop="() => editNode(node,data)" title="修改"></el-button>
                <el-button type="text" icon="el-icon-delete" @click.stop="() => delNode(node,data)" title="删除"></el-button>
              </span>
            </span>
          </el-tree>
        </div>

        <div v-if="activeName == '2'">
          <div>
            <el-checkbox v-model="checked" disabled>内部主体账户：按系统配置</el-checkbox>
          </div>
          <div style="margin-top:15px">
            <el-checkbox v-model="checked" disabled>合作账户</el-checkbox>
          </div>
          <div>
            <el-table :data="paySetData" border class="doc_table" style="width:99%;margin-top:10px">
              <el-table-column prop="compName" label="账户名称" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="username" label="出纳" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="cashierType" label="权限" min-width="300" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="关联主体" min-width="150" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="是否CBS账户" min-width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="暂支是否无需核销" min-width="140" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="操作" min-width="100" :show-overflow-tooltip="true" align="center">
                <template slot-scope={row}>
                  <div class="injuryTabBtn">
                    <el-button type="text" @click="editPaySet(row)">编辑</el-button>
                    <el-button type="text" @click="delPaySet(row)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-if="activeName == '3'">
          <el-table :data="accountData" border class="doc_table" style="width:99%;margin-top:10px">
            <el-table-column prop="acountName" label="户名" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="acount" label="账户" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName2=='3'">
            </el-table-column>
            <el-table-column prop="openingBank" :label="activeName2=='3' ? '开户行' : '备注'" min-width="200" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="compName" label="服务公司" min-width="180" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="isCbsAcount" label="是否CBS账户" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName2=='3'">
            </el-table-column>
            <el-table-column prop="name" label="操作" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" @click="editAccount(row)">编辑</el-button>
                  <el-button type="text" @click="delAccount(row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="block" v-if="activeName!='1'">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageModel.page" :page-size="Number(listQuery.pageModel.rows)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="新增规则" :visible.sync="showAddRule" width="600px">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" size="mini" label-width="140px">
        <el-form-item label="规则名称" prop="ruleName">
          <el-input v-model="ruleForm.ruleName" placeholder="" size="small" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="资金用途" prop="fundUse">
          <el-select v-model="ruleForm.fundUse" placeholder="" size="small" style="width: 180px;" clearable filterable>
            <el-option value="全部"></el-option>
            <el-option value="新增"></el-option>
            <el-option value="社保公积金"></el-option>
            <el-option value="个税"></el-option>
            <el-option value="增值税"></el-option>
            <el-option value="商保"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支出方式" prop="expendpattern">
          <el-select v-model="ruleForm.expendpattern" placeholder="" size="small" style="width: 180px;" clearable filterable>
            <el-option value="发薪"></el-option>
            <el-option value="暂支"></el-option>
            <el-option value="报销"></el-option>
            <el-option value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优先级" prop="priority">
          <div>
            <el-input v-model="ruleForm.priority" type="number" style="width:180px" size="small"></el-input>
            <span class="tips">注：数字越大，优先级越高</span>
          </div>
        </el-form-item>
        <el-form-item label="金额上限" prop="fundUp">
          <div class="flex">
            <el-input v-model="ruleForm.fundUp" style="width:140px" size="small" :disabled="fundUpInfinite"></el-input>
            <span>元</span>
            <el-checkbox v-model="fundUpInfinite" @change="changeCheck" style="margin-left:15px">不限</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label="金额下限" prop="fundDown">
          <div class="flex">
            <el-input v-model="ruleForm.fundDown" style="width:140px" size="small" :disabled="fundDownInfinite"></el-input>
            <span>元</span>
            <el-checkbox v-model="fundDownInfinite" @change="changeCheck" style="margin-left:15px">不限</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label="使用资金天数上限" prop="fundDayUp">
          <div class="flex">
            <el-input v-model="ruleForm.fundDayUp" style="width:140px" size="small" :disabled="fundDayUpInfinite"></el-input>
            <span>日</span>
            <el-checkbox v-model="fundDayUpInfinite" @change="changeCheck" style="margin-left:15px">不限</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label="使用资金天数下限" prop="fundDayDown">
          <div class="flex">
            <el-input v-model="ruleForm.fundDayDown" style="width:140px" size="small" :disabled="fundDayDownInfinite"></el-input>
            <span>日</span>
            <el-checkbox v-model="fundDayDownInfinite" @change="changeCheck" style="margin-left:15px">不限</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label="费率类型" prop="rateType">
          <div class="flex">
            <el-select v-model="ruleForm.rateType" placeholder="" size="small" style="width: 130px;" clearable filterable>
              <el-option value="日费率"></el-option>
              <el-option value="月费率"></el-option>
              <el-option value="年费率"></el-option>
            </el-select>
            <el-input v-model="ruleForm.rate" style="width:100px;margin: 0 10px;" size="small"></el-input>
            <span>%</span>
          </div>
        </el-form-item>
        <el-form-item label="生效起止时间" prop="effectStart">
          <div class="flex">
            <el-date-picker v-model="ruleForm.effectStart" type="date" value-format="yyyy-MM-dd" size="small" style="width:130px;margin-right:10px">
            </el-date-picker>
            <span> ~ </span>
            <el-date-picker v-model="ruleForm.effectEnd" type="date" value-format="yyyy-MM-dd" size="small" style="width:130px;margin-left:10px">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="免息天数">
          <el-input v-model="ruleForm.freeDays" type="number" style="width:180px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="免收月">
          <el-input v-model="ruleForm.freeMonth" type="number" style="width:180px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="实际开票天数上限">
          <div class="flex">
            <el-input v-model="ruleForm.invFundDayUp" type="number" style="width:140px" size="small"></el-input>
            <span>日</span>
            <!-- <el-checkbox v-model="invFundDayUpInfinite" @change="changeCheck" style="margin-left:15px">不限</el-checkbox> -->
          </div>
        </el-form-item>
        <el-form-item label="实际开票天数下限">
          <div class="flex">
            <el-input v-model="ruleForm.invDayDown" type="number" style="width:140px" size="small"></el-input>
            <span>日</span>
            <!-- <el-checkbox v-model="invDayDownInfinite" @change="changeCheck" style="margin-left:15px">不限</el-checkbox> -->
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddRule = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddRules">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增科目" :visible.sync="showAddNode" width="500px">
      <el-form :model="nodeForm" ref="nodeForm" :rules="nodeRules" label-width="100px">
        <el-form-item label="科目编号" prop="code">
          <el-input v-model="nodeForm.code" placeholder="" size="small" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="科目名称" prop="name">
          <el-input v-model="nodeForm.name" placeholder="" size="small" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="nodeForm.sort" type="number" placeholder="" size="small" style="width: 180px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddNode = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSaveNode" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="paySetType =='add' ? '新增合作账户打款设置' : '修改合作账户打款设置'" :visible.sync="showAddPaySet" width="500px">
      <el-form :model="paySetForm" ref="paySetForm" :rules="payRules" label-width="100px">
        <el-form-item label="账户名称" prop="code">
          <el-input v-model="paySetForm.compName" placeholder="" size="small" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="出纳" prop="code">
          <el-select v-model="user" placeholder="" clearable size="small" style="width: 300px;" value-key="Userid" filterable @change="changeUser">
            <el-option v-for="(item,index) in customerList" :key="index" :label="item.Username" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="权限" prop="code">
          <el-select v-model="paySetForm.cashierType" placeholder="" clearable size="small" style="width: 300px;" filterable>
            <el-option value="暂支打款"></el-option>
            <el-option value="暂支核销"></el-option>
            <el-option value="日志报销"></el-option>
            <el-option value="新增业务"></el-option>
            <el-option value="其他"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddPaySet = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddPaySet" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="paySetType =='add' ? '新增合作账户设置' : '修改合作账户设置'" :visible.sync="showAddAccount" width="500px">
      <el-form :model="accountForm" ref="accountForm" :rules="accountRules" label-width="100px">
        <el-form-item label="户名" prop="acountName">
          <el-input v-model="accountForm.acountName" placeholder="" size="small" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="acount" v-if="listQuery.compType==3">
          <el-input v-model="accountForm.acount" placeholder="" size="small" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item :label="listQuery.compType==3 ? '开户行' : '备注'" prop="openingBank">
          <el-input v-model="accountForm.openingBank" placeholder="" size="small" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="服务公司" prop="compName">
          <el-select v-model="accountForm.compName" placeholder="" value-key="Projectid" size="small" style="width: 300px;" clearable filterable>
            <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户类型" prop="compType">
          <el-radio-group v-model="accountForm.compType">
            <el-radio :label="3">真实账户</el-radio>
            <el-radio :label="4">虚拟账户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="openingBank" v-if="listQuery.compType==3">
          <el-checkbox v-model="accountForm.isCbsAcount" :true-label="1" :false-label="0">CBS账户</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddAccount = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddAccount" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="适用项目" :visible.sync="showSetProject" width="500px">
      <el-form label-width="80px">
        <el-form-item label="适用项目">
          <el-select v-model="projectids" multiple placeholder="" size="small" clearable filterable style="width:300px">
            <el-option v-for="(item,index) in proList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSetProject = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSetProject" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    row
  } from "mathjs";
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [{
              property: "updataTime",
              order: 0
            }]
          },
          projectid: 0,
          id: "",
          compName: "",
          acountName: "",
          acount: "",
          openingBank: "",
          isCbsAcount: "",
          compType: 3,
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
        },
        totalCount: 0,
        listQuery2: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "updataTime",
              order: 0
            }]
          },
          compName: ''
        },
        activeName: '0',
        ruleForm: {
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
          id: "",
          ruleName: '', //规则名称
          fundUse: "", //用途
          expendpattern: "", //支出方式
          fundUp: '', //金额上限
          fundDown: '', //金额下限
          fundDayUp: '', //使用资金天数上限
          fundDayDown: '', //使用资金天数下限
          rateType: "", //费率类型日月年
          rate: '', //费率
          effectStart: "", //生效起
          effectEnd: "", //生效结束
          disableStr: "启用", //停用 启用
          priority: '',
          freeDays: '', //免息天数
          freeMonth: '',
          invFundDayUp: '', //实际开票天数上限
          invDayDown: '', //实际开票天数下限
        },
        fundUpInfinite: true, //金额上限不限
        fundDownInfinite: true, //金额下限不限
        fundDayUpInfinite: true, //使用资金天数上限不限
        fundDayDownInfinite: true, //使用资金天数下限不限
        invFundDayUpInfinite: true, //实际开票天数上限
        invDayDownInfinite: true, //实际开票天数下限
        showAddRule: false,
        tableData: [],
        loading: false,
        rules: {
          ruleName: {
            required: true,
            message: '请输入规则名称',
            trigger: 'blur'
          },
          fundUse: {
            required: true,
            message: '请选择资金用途',
            trigger: 'change'
          },
          expendpattern: {
            required: true,
            message: '请选择支出方式',
            trigger: 'change'
          },
          fundUp: {
            required: true,
            message: '请输入金额上限',
            trigger: 'blur'
          },
          fundDown: {
            required: true,
            message: '请输入金额下限',
            trigger: 'blur'
          },
          fundDayUp: {
            required: true,
            message: '请输入使用资金天数上限',
            trigger: 'blur'
          },
          fundDayDown: {
            required: true,
            message: '请输入使用资金天数下限',
            trigger: 'blur'
          },
          rateType: {
            required: true,
            message: '请选择费率类型',
            trigger: 'change'
          },
          effectStart: {
            required: true,
            message: '请选择生效起止时间',
            trigger: 'change'
          },
        },
        treeData: [],
        activeName2: '3',
        nodeForm: {
          userid: Cookies.get("userid-b"),
          parentId: null,
          id: '',
          name: '',
          code: '',
          sort: 0,
          remark: '',
        },
        nodeRules: {
          code: {
            required: true,
            message: '请输入编号',
            trigger: 'blur'
          },
          name: {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
        },
        showAddNode: false,
        isBtnLoading: false,
        checked: true,
        paySetType: '',
        paySetData: [],
        paySetForm: {
          id: '',
          compName: '',
          cashierType: '',
          userid: '',
          currentUserid: Cookies.get("userid-b"),
          username: '',
        },
        showAddPaySet: false,
        user: '',
        payRules: {},
        paySetData: [],
        customerList: [], //客服列表
        accountForm: {
          id: '',
          compName: '',
          acountName: '', //户名
          acount: '', //账号
          openingBank: '', //开户行
          isCbsAcount: 1, //是否CBS账号
          compType: '', //3真实 4虚拟
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
        },
        accountData: [],
        legList: [],
        showAddAccount: false,
        accountRules: {
          acountName: {
            required: true,
            message: '请输入户名',
            trigger: 'blur'
          },
          acount: {
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          },
        },
        showSetProject: false,
        id: '',
        projectids: '',
        proList: [],
      }
    },
    created() {
      // this.getNodeData();
      this.getMemberList();
      this.getlegalsubjectlist();
      this.getList();
      this.getSearchJobProList();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      // 获取项目列表
      getSearchJobProList() {
        let proNameQuery = {
          roletype: localStorage.loginRoletype,
          projectname: "",
          perpage: 10000,
          currpage: 1,
        };
        xz.getProjectLists(proNameQuery).then((res) => {
          if (res.status == "ok") {
            this.proList = res.msg;
          } else {
            this.proList = [];
          }
        });
      },
      changeTab() {
        this.listQuery.pageModel.page = 1;
        if (this.activeName == '1') {
          this.getNodeData();
        } else if (this.activeName == '2') {
          this.GetAdvCompCashierList();
        } else if (this.activeName == '3') {
          this.GetAdvCooperationaAcountList()
        }
      },
      getMemberList() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        }
        xz.getauthUserInfoByorgancode(data).then((res) => {
          if (res.status == "ok") {
            this.customerList = res.msg;
          } else {
            this.customerList = [];
          }
        });
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      addRule() {
        this.ruleForm = {
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
          id: "",
          ruleName: "",
          fundUse: "", //用途
          expendpattern: "", //支出方式
          fundUp: '', //金额上限
          fundDown: '', //金额下限
          fundDayUp: '', //使用资金天数上限
          fundDayDown: '', //使用资金天数下限
          rateType: "", //费率类型日月年
          rate: '', //费率
          effectStart: "", //生效起
          effectEnd: "", //生效结束
          disableStr: "启用", //停用 启用
          priority: '',
          freeDays: '', //免息天数
          freeMonth: '',
          invFundDayUp: '', //实际开票天数上限
          invDayDown: '', //实际开票天数下限
        }
        this.fundUpInfinite = true; //金额上限不限
        this.fundDownInfinite = true; //金额下限不限
        this.fundDayUpInfinite = true; //使用资金天数上限不限
        this.fundDayDownInfinite = true; //使用资金天数下限不限
        this.invFundDayUpInfinite = true;
        this.invDayDownInfinite = true;
        this.showAddRule = true;
      },
      changeCheck() {},
      //鼠标悬浮
      mouseenter(data) {
        this.$set(data, 'show', true)
      },
      mouseleave(data) {
        this.$set(data, 'show', false)
      },
      append(node, data) {
        this.showAddNode = true;
        this.nodeForm.parentId = data.id;
        this.nodeForm.code = '';
        this.nodeForm.name = '';
        this.nodeForm.sort = '';
        this.nodeForm.id = '';
      },
      editNode(node, data) {
        this.nodeForm.id = data.id;
        this.nodeForm.code = data.code;
        this.nodeForm.name = data.name;
        this.nodeForm.parentId = data.parentId;
        this.nodeForm.remark = data.remark;
        this.nodeForm.sort = data.sort;
        this.showAddNode = true;
      },
      delNode(node, data) {
        let d = {
          id: data.id,
          isDeleted: 1
        }
        xz.AdvanceFun(d, 'AddUpdataDicVal').then(res => {
          if (res.status == 'ok') {
            this.$message.success('删除成功！');
            this.getNodeData();
          } else {
            this.$message.success(res.msg)
          }
        })
      },
      //展开下级
      loadNode(node, resolve) {
        if (this.treeData.length > 0) {
          console.log(node)
          let data = {
            parentId: node.data.id
          }
          xz.AdvanceFun(data, 'GetDicList').then(res => {
            if (res.status == 'ok') {
              resolve(res.data)
            } else {
              resolve([])
            }
          })
        }
      },
      //确认新增、修改费用
      confirmSaveNode() {
        this.$refs['nodeForm'].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.AdvanceFun(this.nodeForm, 'AddUpdataDicVal').then(res => {
              if (res.status == 'ok') {
                this.isBtnLoading = false;
                this.showAddNode = false;
                this.$message.success('保存成功！');
                this.getNodeData();
              } else {
                this.isBtnLoading = false;
                this.showAddNode = false;
                this.$message.success(res.msg)
              }
            })
          }
        })
      },
      getNodeData() {
        let data = {
          parentId: 0
        }
        xz.AdvanceFun(data, 'GetDicList').then(res => {
          if (res.status == 'ok') {
            this.treeData = res.data;
          } else {
            this.treeData = []
          }
        })
      },
      addPaySet() {
        this.paySetForm = {
          id: '',
          compName: '',
          cashierType: '',
          userid: '',
          currentUserid: Cookies.get("userid-b"),
          username: '',
        }
        this.user = ''
        this.paySetType = 'add';
        this.showAddPaySet = true;
      },
      changeUser(val) {
        this.paySetForm.userid = val.Userid;
        this.paySetForm.username = val.Username;
        console.log(val, this.paySetForm)
      },
      //新增 修改 合作公司
      confirmAddPaySet() {
        this.$refs['paySetForm'].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.AdvanceFun(this.paySetForm, 'AddUpdataAdvCompCashier').then(res => {
              if (res.status == 'ok') {
                this.isBtnLoading = false;
                this.showAddPaySet = false;
                this.$message.success('保存成功！');
                this.GetAdvCompCashierList();
              } else {
                this.isBtnLoading = false;
                this.showAddPaySet = false;
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
      //获取合作公司列表
      GetAdvCompCashierList() {
        this.loading = true;
        xz.AdvanceFun(this.listQuery2, 'GetAdvCompCashierList').then(res => {
          if (res.status == 'ok') {
            this.paySetData = res.data.data;
            this.loading = false;
          } else {
            this.paySetData = [];
            this.loading = false;
          }
        })
      },
      editPaySet(row) {
        this.paySetForm = {
          id: row.id,
          compName: row.compName,
          cashierType: row.cashierType,
          userid: row.userid,
          currentUserid: Cookies.get("userid-b"),
          username: row.username,
        }
        this.user = {
          Userid: row.userid,
          Username: row.username
        }
        this.paySetType = 'edit';
        this.showAddPaySet = true;
      },
      delPaySet(row) {
        let d = {
          id: row.id,
          isDeleted: 1
        }
        xz.AdvanceFun(d, 'AddUpdataAdvCompCashier').then(res => {
          if (res.status == 'ok') {
            this.$message.success('删除成功！');
            this.GetAdvCompCashierList();
          } else {
            this.$message.success(res.msg)
          }
        })
      },
      addAccount() {
        this.accountForm = {
          id: '',
          compName: '',
          acountName: '', //户名
          acount: '', //账号
          openingBank: '', //开户行
          isCbsAcount: 1, //是否CBS账号
          compType: Number(this.activeName2), //3真实 4虚拟
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
        }
        this.paySetType = 'add';
        this.showAddAccount = true;
      },
      changeTab2() {
        this.listQuery.compType = Number(this.activeName2);
        this.GetAdvCooperationaAcountList();
      },
      //保存合作账户
      confirmAddAccount() {
        this.$refs['accountForm'].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.AdvanceFun(this.accountForm, 'AddUpdataAdvCooperationaAcount').then(res => {
              if (res.status == 'ok') {
                this.isBtnLoading = false;
                this.showAddAccount = false;
                this.$message.success('保存成功！');
                this.GetAdvCooperationaAcountList();
              } else {
                this.isBtnLoading = false;
                this.showAddAccount = false;
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
      //获取合作账户列表
      GetAdvCooperationaAcountList() {
        this.loading = true;
        xz.AdvanceFun(this.listQuery, 'GetAdvCooperationaAcountList').then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.accountData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount
          } else {
            this.loading = false;
            this.accountData = [];
            this.totalCount = 0;
          }
        })
      },
      //分页
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val)
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.pageModel.page = 1
        this.listQuery.pageModel.rows = Number(val)
        this.getList()
      },
      getList() {
        if (this, this.activeName == '0') {
          this.GetAdvFinanCostRules();
        } else if (this.activeName == '2') {
          this.GetAdvCompCashierList();
        } else if (this.activeName == '3') {
          this.GetAdvCooperationaAcountList();
        }
      },
      //42财务成本规则列表
      GetAdvFinanCostRules() {
        let data = {
          projectid: this.listQuery.projectid,
          pageSize: this.listQuery.pageModel.rows,
          pageNum: this.listQuery.pageModel.page,
        }
        xz.GetAdvFinanCostRules(data).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.count;
          }
        })
      },
      //编辑合作账户
      editAccount(row) {
        this.accountForm = {
          id: row.id,
          compName: row.compName,
          acountName: row.acountName, //户名
          acount: row.acount, //账号
          openingBank: row.openingBank, //开户行
          isCbsAcount: Number(row.isCbsAcount), //是否CBS账号
          compType: row.compType, //3真实 4虚拟
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
        }
        this.showAddAccount = true;
      },
      //删除合作账户
      delAccount(row) {
        let d = {
          id: row.id,
          isDeleted: 1
        }
        xz.AdvanceFun(d, 'AddUpdataAdvCooperationaAcount').then(res => {
          if (res.status == 'ok') {
            this.$message.success('删除成功！');
            this.GetAdvCooperationaAcountList();
          } else {
            this.$message.success(res.msg)
          }
        })
      },
      editRule(row) {
        this.ruleForm = row;
        if (!row.fundUp) {
          this.fundUpInfinite = true;
        }
        if (!row.fundDown) {
          this.fundDownInfinite = true;
        }
        if (!row.fundDayUp) {
          this.fundDayUpInfinite = true;
        }
        if (!row.fundDayDown) {
          this.fundDayDownInfinite = true;
        }
        if (!row.invFundDayUp) {
          this.invFundDayUpInfinite = true;
        }
        if (!row.invDayDown) {
          this.invDayDownInfinite = true;
        }
        this.showAddRule = true;
      },
      confirmAddRules() {
        if (this.fundUpInfinite) {
          this.ruleForm.fundUp = 10000000;
        }
        if (this.fundDownInfinite) {
          this.ruleForm.fundDown = 0;
        }
        if (this.fundDayUpInfinite) {
          this.ruleForm.fundDayUp = 10000;
        }
        if (this.fundDayDownInfinite) {
          this.ruleForm.fundDayDown = 0;
        }
        console.log(this.ruleForm);
        this.isBtnLoading = true;
        xz.AdvanceFun(this.ruleForm, 'AddUpdataAdvFinanCostRules').then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功！');
            this.isBtnLoading = false;
            this.showAddRule = false;
            this.getList();
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
            this.showAddRule = false;
          }
        })
      },
      //停用/启用
      enable(row) {
        let data = {
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
          id: row.id,
          disableStr: row.disableStr == '启用' ? '停用' : '启用'
        }
        xz.AdvanceFun(data, 'AddUpdataAdvFinanCostRules').then(res => {
          if (res.status == 'ok') {
            this.$message.success(data.disableStr + '成功！');
            this.getList()
          } else {
            this.$message.error(res.msg);
            this.getList()
          }
        })
      },
      del(row) {
        let data = {
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
          id: row.id,
          IsDeleted: true
        }
        xz.AdvanceFun(data, 'AddUpdataAdvFinanCostRules').then(res => {
          if (res.status == 'ok') {
            this.$message.success('删除成功！');
            this.getList()
          } else {
            this.$message.error(res.msg);
            this.getList()
          }
        })
      },
      setProject(row) {
        this.id = row.id;
        if (row.projectIds) {
          this.projectids = JSON.parse(row.projectIds.replace(/'/g, '"'));
        } else {
          this.projectids = []
        }
        this.showSetProject = true;
      },
      confirmSetProject() {
        // if (this.projectids.length > 0) {
        let ids = this.projectids.toString();
        let str = `?id=${this.id}&ids=${ids}`;
        this.isBtnLoading = true;
        xz.ArdCurStatGetFun('FinancialCostRulesAdaptProjects', str).then(res => {
          if (res.status == 'ok') {
            this.isBtnLoading = false;
            this.getList();
            this.showSetProject = false;
            this.$message.success("操作成功！");
          } else {
            this.isBtnLoading = false;
            this.$message.error(res.msg);
          }
        })
        // }else{
        //   this.$message.error('请至少选择1个项目！')
        // }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .level_item {
    font-size: 14px;
  }

  .departTree_btn {
    margin-left: 5px;
  }

  .tips {
    color: red;
    margin-left: 15px;
  }
</style>
<style>
  .page_acSet .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_acSet .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_acSet .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_acSet .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_acSet .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_acSet .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_acSet .setTitle .el-button--text {
    color: #409eff;
    font-size: 13px;
    padding: 0;
    margin-left: 10px;
  }

  .departTree_btn i {
    font-size: 16px;
  }

  .departTree_btn i.el-icon-plus {
    color: rgb(237, 175, 84);
  }

  .departTree_btn i.el-icon-edit {
    color: #409eff;
  }

  .departTree_btn i.el-icon-delete {
    color: #f56c6c;
  }

  .departTree .custom-tree-node {
    width: 240px;
  }
</style>